import {Line, mixins} from 'vue-chartjs'

export default Line.extend({
    mixins: [mixins.reactiveProp],
    props: {"items": {}, "labels":{}, "chartData":{}, "data": {}, 'options': {}},
    data () {
        return {
            defaultOptions: {
                responsive: true,
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: false,
                        }
                    }]
                }
            }
        }
    },
    mounted () {

        this.renderChart({
            labels: this.labels,
            datasets: this.items,
        }, this.options ? this.options : this.defaultOptions)


    },
    methods: {},
    watch: {
        labels: {
            handler: function (newData, oldData) {
                this._chart.data.labels = newData;
                this._chart.update();
            },
        },
        items: {
            handler: function (newData, oldData) {
                this._chart.data.datasets = newData;
                this._chart.update();
            }
        }
    },

})


// WEBPACK FOOTER //
// ./src/components/productDetails/PriceHistoryChart.js